module.exports = __webpack_public_path__ + "img/iso-toiture.c5e44c00.svg";